/**
 * @fileoverview GET handler for the "/data_objects/object_relationship_type_schema" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsObjectRelationshipTypeSchema } from "./constants";
import type { GetCustomObjectsObjectRelationshipTypeSchemaResult } from "./types";
import { isGetCustomObjectsObjectRelationshipTypeSchemaResult } from "./validators";

export const getCustomObjectsObjectRelationshipTypeSchema = reactQueryFetcherAdapter(
  customObjectsObjectRelationshipTypeSchema,
  (
    signal: AbortSignal,
    typeName: string,
    relKind: string,
    relatedTypeName: string
  ): Promise<GetCustomObjectsObjectRelationshipTypeSchemaResult> => {
    return fetch(
      "/data_objects/object_relationship_type_schema",
      "GET",
      { type_name: typeName, rel_kind: relKind, related_type_name: relatedTypeName },
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsObjectRelationshipTypeSchemaResult
);
